import { z } from 'zod';
export const schemaOptionsTypes = z.union([z.literal('entity'), z.literal('enum'), z.literal('block')]);
export const schemaAiAssistantPrefix = z.object({
    type: schemaOptionsTypes,
    value: z.string(),
});
export const schemaAiAssistant = z.object({
    prefix: schemaAiAssistantPrefix.optional(),
});
export const optionalPanel = z.object({
    name: z.string().optional().nullable(),
    type: schemaOptionsTypes.optional().nullable(),
});
export const schemaSliceState = z.object({
    dsl: z.object({
        past: z.array(z.string()),
        present: z.string(),
        future: z.array(z.string()),
    }),
    pendingDsl: z.string().optional(),
    aiAssistant: schemaAiAssistant.optional(),
    showOptionsPanel: z.boolean(),
    optionsPanel: optionalPanel.optional(),
    schemaVisualizer: z
        .object({
        nodes: z.array(z.any()),
        edges: z.array(z.any()),
        viewport: z.any(),
    })
        .optional()
        .nullable(),
});
//# sourceMappingURL=schemaSlice.js.map